import { render, staticRenderFns } from "./Widget20_Outbound.vue?vue&type=template&id=600b4d54"
import script from "./Widget20_Outbound.vue?vue&type=script&lang=js"
export * from "./Widget20_Outbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports